import { gql } from "@apollo/client";

export const CREATE_MODEL = gql`
    mutation createVehicleModel($data: CreateVehicleModelInput!) {
        createVehicleModel(data: $data) {
            id
            name
        }
    }
`;

export const UPDATE_MODEL = gql`
    mutation updateVehicleModel($data: UpdateVehicleModelInput!) {
        updateVehicleModel(data: $data) {
            id
            name
        }
    }
`;

export default CREATE_MODEL;
